import { gql } from "@apollo/client";

const DATA_FLOW_QUERY = gql`
  query GetDataFlow {
    getDataFlow {
      scriptbookId
      scriptbookDescription
      steps {
        kind
        name
        declarationName
        project
        line
        sourceTables
        destTables
        inputs
        outputs
      }
    }
  }
`;

export { DATA_FLOW_QUERY };
